// Container: max width, padding, responsive
export default function Container({ children }) {
  return (
    <div className="mx-auto max-w-screen-xl px-4 sm:px-8 lg:px-12">
      {children}
    </div>
  );
}